import React, { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { DropDown, Icon } from 'components/ui';

import { logout } from 'store/actions/auth.action';
import { authSelector } from 'store/reducers/auth.reducer';

import logo from 'assets/images/logo.png';
import ReactGA from 'hooks/useGA';
import DefultProfilePfoto from 'assets/images/profile_img.png'

const ProfileDropDown = () => {
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(logout());
  };
  const handleLinkClick = (label: string) => {
    ReactGA.event({
      category: 'Dropdown',
      action: 'Link Click',
      label
    })
  }

  return (
    <ul>
      <li>
        <Link to="/profile" onClick={() => handleLinkClick('Profile')}>Profile</Link>
      </li>
      <li>
        <Link to="/subscription" onClick={() => handleLinkClick('Subscription')}>Subscription</Link>
      </li>
      <li onClick={handleLogout}>Logout</li>
    </ul>
  );
};

export const Header: React.FC<any> = ({ sidebarOpen, setSidebarOpen, HIPPAAuthFormOpen }) => {
  const { profile } = useSelector(authSelector);
  const { pathname } = useLocation();
  const sidebarToggle = () => {
    setSidebarOpen(!sidebarOpen)
  }

  return (
    <header className="header-component row p-3">
      <div className="col-sm-2">
        <Link to="/">
          <img className='logo' src={logo} alt="logo" />
        </Link>
      </div>
      {(window.location.href.indexOf("govt_document") > -1 || window.location.href.indexOf("patient_document") > -1) ? null : (<div>
        {profile?.date_of_birth == null ? (
        <div className={'error_dob alert alert-warning mobile'+pathname}> Your account requires an update. Please <a href="/p/profile" className='text-primary'>click here</a> to update your <strong>date of birth</strong></div>
      ) : null}
      </div>)}
      {!HIPPAAuthFormOpen && (<>
        <div className="col-md-auto d-none d-lg-block">
          <DropDown placement="bottomRight" content={<ProfileDropDown />}>
            {profile && (
              <div className={'profile d-flex align-items-center'}>
                {profile.avatarUrl !='' && <img className={'avatar'} src={profile.avatarUrl} alt="avatar" />}
                {profile.avatarUrl =='' && <img className={'avatar'} src={DefultProfilePfoto} alt="avatar" />}
                <div className={'name'}>{profile.name}</div>
                <Icon name="arrow-down" className={'icon'} />
              </div>
            )}
          </DropDown>
        </div>
        <div className='col-auto d-lg-none'>
          {sidebarOpen ? <span className='navbar-icon' onClick={sidebarToggle}>&#10006;</span> : <span className='navbar-icon' onClick={sidebarToggle}>&#9776;</span>}
        </div>
      </>)}
    </header>
  );
};